module.exports = __webpack_public_path__ + "img/cloud_full.f838fa25.png";